export const tradingContest = {
  cyjyds: "트레이딩 대회에 참여해보세요",
  jsjxmh: "깜짝 블라인드 박스를 잠금 해제하고 슈퍼 상품을 획득하세요",
  hdsj: "활동 시간",
  mrjxsj: "매일 00:00부터 23:59 UTC+8까지 실시됩니다.",
  ckxxgz: "세부 규칙",
  wdjj: "내 보너스",
  jlkj: "카운트다운",
  cjjc: "슈퍼 상금 풀",
  jjmrzj: "일일 보너스 누적 증가",
  kqxjd: "새로운 스테이지를 열고 보상 개수를 늘려보세요",
  dyjd: "첫 번째 단계",
  dejd: "두 번째 단계",
  dsjd: "세 번째 단계",
  dsijd: "4단계",
  jrmhjj: "오늘의 블라인드박스 보너스",
  syjj: "남은 보너스",
  yblqje: "받은 금액",
  tjmh: "특별한",
  yjmh: "1단계 상자",
  ejmh: "2단계 상자",
  sjmh: "3단계 상자",
  jj: "보너스: ",
  gs: "개",
  djdkrymh: "놀라운 블라인드 박스를 열려면 클릭하세요",
  kydk: "오늘 열 수 있어요",
  jxmh: "서프라이즈 블라인드 박스",
  dkmhxyxx: "블라인드 박스를 열려면 별 {amount}개가 필요합니다. ",
  xzyyxx: "이제 별 {amount}개가 생겼습니다",
  xxqlsj: "별 지우기 시간 : {date} （별이 지워지기 전에 블라인드 박스를 모아주세요）",
  wdxx: "내 별",
  xxhq: "별 획득",
  hqxxtj: "별을 얻는 방법",
  yxhysxf: "영구 계약: 처리 수수료 {amount}U마다 별 1개를 획득하세요.",
  qqhysxf: "옵션 계약: 거래량 {amount}U당 별 1개 획득",
  youxihysxf: "GameFi: 거래량 {amount}U당 별 1개 획득",
  gxhd: "축하합니다",
  jlydrzh: "보상은 귀하의 '{account}'에 적립되었습니다.",
  qzjzhck: "보려면 Gamefi 계정으로 이동하세요",
  bwcjjc: "슈퍼 상금 풀",
  qmxjyds: "올스타 트레이딩 대회",
  gbgbyb: "감히 한번 시도해 보시겠어요?",
  bwcjjcdnn: "바이킹 슈퍼 상금풀, 매일 블라인드박스 상금의 {amount}%를 당신에게 드립니다!",
  cjjcqmxjys: "코인킹 슈퍼 상금 풀 올스타 트레이딩 대회 상금의 {amount}%가 매일 블라인드박스에 추가됩니다. ",
  syyxbd: "오픈하고 소액으로 당첨되세요!",
  zgtk: "정상에 도달하고 싶나요? 와서 싸워라!",
  zhyz: "최종 전투까지 일일 상금의 {amount}%가 누적됩니다. ",
  dfdj: "바이킹 부문 최우수상은 누가 받을 수 있나요?",
  gsjj: "바이킹 슈퍼 상금 풀 올스타 트레이딩 대회의 고수들이 모여 ",
  qmxpk: "올스타 PK의 실제 결과를 확인해보세요!",
  jymh: "트레이딩, 블라인드박스, 랭킹까지 바이킹 아레나에서 즐겨보세요!",
  zzbzy: "무기한 계약, 옵션, GameFi, 현물 거래, 주변 게임 플레이가 레이어별로 업그레이드되며 매주 동일하지 않습니다!",
  jlfh: "바이킹 슈퍼 상금 풀 올스타 트레이딩 대회, 명성과 부를 얻고 영웅이 될 수 있도록 넉넉한 보상이 여러분을 기다리고 있습니다!",
  mh: "블라인드 박스",
  cb: "정상으로 돌진하다",
  jy: "거래",
  syxxs: "남은 별 수",
  xxbhs: "별의 개수가 변경됩니다.",
  sjlx: "이벤트 유형",
  jycp: "무역상품",
  jye: "거래량",
  myxgjl: "まだ関連する報酬を受け取っていません",
  jyhd: "거래 획득",
  ql: "분명한",
  kqmh: "블라인드 박스 열기",
  yx: "GameFi 게임",
  bchdyjs: "본 이벤트는 종료되었습니다",
  gffjj: "이번 대회에서는 총 상품이 배포됩니다.",
  kqmhsl: "블라인드 박스 수량 활성화",
  cjjcjj: "슈퍼 잭팟 보너스",
  cjjchjmd: "슈퍼 상금 풀 수상자 목록",
  jjdyyh: "보너스가 사용자의 자금 계좌에 적립되었습니다",
  hdjj: "보너스를 받다",
  wff: "발급되지 않음",
  mhhjjl: "블라인드 박스",
  cjdjhjjl: "슈퍼상 수상 기록",
  jjse: "보너스 금액",
  xhxxs: "소모된 별 수",
  bwqmxgz: "바이킹 올스타 트레이딩 대회 규칙",
  hdnr: "활동 내용",
  hdnrgz: "코인킹 슈퍼 상금 풀 올스타 거래 대회는 무기한 계약, 옵션 계약, GameFi 게임 및 현물 거래의 네 가지 주요 영역을 다룹니다. 이벤트는 4주로 나누어 매주 새로운 거래 상품이 점진적으로 잠금 해제되어 다차원 거래 도전에서 '별'을 획득하고 넉넉한 보상을 얻을 수 있습니다. 일일 상금의 {total}%는 블라인드 박스 추첨에 사용되며, 깜짝 보상은 즉시 제공됩니다! 남은 {amount}%는 대회 종료까지 적립되며, 거래 순위에 따라 가장 높은 보상이 나눠집니다!",
  hdjd: "활동 단계",
  jbjs: "점차적으로 잠금 해제, 경쟁 업그레이드 4주기",
  dyzq: "첫 번째 사이클",
  kqyxhy: "무기한 계약 거래를 활성화하세요. 거래량이 많을수록 더 많은 스타 포인트와 상금 풀 보상도 높아집니다!",
  dezq: "두 번째 사이클",
  jmqqjy: "옵션 계약 거래를 늘리고 수익과 손실에 대한 양방향 잭팟을 획득하여 별 수를 다시 업그레이드할 수 있습니다.",
  dszq: "세 번째 주기",
  cjgejc: "GameFi 게임에 참여하고 다양한 거래 경험을 통해 별을 획득하고 높은 상금을 획득하세요.",
  dsizq: "네 번째 주기",
  gfzzdj: "블라인드박스 상금풀은 처음 3주 동안 계속해서 오픈될 예정이며, 최종 상금을 공유하기 위한 현물 거래 목록도 별도로 구성될 예정입니다!",
  jzszjs: "상금 풀 상금 계산",
  jxmhgz1: "일일 상금의 {amount}%가 블라인드 박스에 할당되며, 100개의 블라인드 박스를 즉시 받을 수 있습니다. 4가지 레벨의 상품을 통해 항상 놀라움을 경험할 수 있습니다. 청구되지 않은 보상은 다음 날 상금 풀에 자동으로 누적되어 수입이 계속 증가할 수 있습니다! 스페셜 블라인드박스, 1레벨 블라인드박스 등이 매일 새로워지며 초고승률이 여러분을 기다리고 있습니다!",
  mhfpmx: "하루 총 블라인드박스 개수는 {total}개로 상금풀의 {amount}%를 차지한다. 블라인드 박스 할당 세부정보:",
  tjmhzb: "스페셜 블라인드 박스 {total}개, 상금의 {amount}% 차지",
  yjmhzb: "1레벨 블라인드 박스는 {total}개로 상금의 {amount}%를 차지합니다.",
  ejmhzb: "2차 블라인드 박스는 {total}개로 총 상금의 {amount}%를 차지합니다.",
  sjmhzb: "{total}개의 3단계 블라인드 박스는 상금 풀의 {amount}%를 차지합니다.",
  kmhxxyq: "블라인드박스 오픈에 필요한 별 개수 : 일일 블라인드박스 상금총액/{text}",
  tips: "참고: 모든 블라인드 박스에 해당하는 보상은 매일 0시에 갱신되며, 전일 발생한 상품별 손익 상금 풀 + 전일 박스 개봉 잔액을 기준으로 재산정됩니다. 위 수준과 비율에 따라 나누어진 금액을 당일 블라인드박스에 배정합니다.",
  mrjyyk: "총 상금 풀은 무기한 계약, 옵션 계약, GameFi 등 세 가지 주요 부문의 일일 거래 손익을 기준으로 합니다.",
  mgyld: "각 이익 주문의 {amount}% = 이익 금액 * {amount}%",
  mrjcljdjs: "일일 상금 풀의 {amount}%는 이벤트가 종료될 때까지 누적되며, 4대 거래 상품 순위 상위 3위 안에 분배됩니다. 지속 상금 풀의 비율은 무기한 계약의 경우 40%, 옵션 30%, GameFi 20%, 현물 10%입니다.",
  yhhyyld: "예: 사용자의 계약 주문 수익이 1000U인 경우 1000*{amount}%={total}U가 당일 상금 풀에 들어갑니다.",
  mgksd: "각 손실 주문의 {amount}% = 실제 손실 금액(손실 - 청산) * {amount}%",
  yhhyks: "예를 들어 사용자의 계약 주문이 실제로 1000U를 잃는 경우 1000*{aount}%={total}U가 당일 상금 풀에 들어가게 됩니다.",
  qqhyyld: "각 이익 주문의 {amount}% = 배팅 금액 * 배당률 * {amount}%",
  qqyhddtz: "예를 들어, 사용자가 옵션 주문에 100U를 베팅하고 10초 동안 수익을 낸 경우 100*65%*{amount}%={total}U가 그날의 상금 풀에 들어갑니다.",
  qqhyksd: "각 손실 주문의 {amount}% = 손실 금액 * {amount}%",
  yhksjrjc: "예를 들어, 사용자의 옵션 주문 손실이 100U인 경우 100*{amount}%={total}U가 당일 상금 풀에 입력됩니다.",
  yxyld: "각 이익 주문의 {amount}% = 배팅 금액 * 배당률 * {amount}%",
  yxddtz: "예: 사용자 gamefi 주문은 확률이 2배라고 가정하고 100U를 베팅합니다. 수익을 내면 100*200%*{amount}%={total}U가 당일 상금에 들어갑니다.",
  yxmgksd: "각 손실 주문의 {amount}% = 손실 금액 * {amount}%",
  yhqqksd: "예를 들어 사용자의 옵션 주문 손실이 100U인 경우 100*{amount}%={total}U가 당일 상금 풀에 입력됩니다.",
  daiding: "보류 중",
  yytz: "활동 조정",
  kaiqi: "열려",
  xhjyjrpm: "현물 거래가 순위에 합류했습니다",
  drjy: "당일 거래하고 다음날 수령",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/kr.js